import {Action} from '@ngrx/store';
import {Department} from '@app/core/models/department.model';
import {IPatchPayload} from '@app/modules/shared/services/department.service';
import {Tenant} from '@app/core/models/tenant.model';
import {ITenantPatchPayload} from '@app/modules/shared/services/tenant.service';
import {QMIntegration} from '@app/core/models/QMIntegration.model';
import {RoundingRule} from '@app/core/models/roundingRule.model';

export enum EDepartmentSettingsActions {
	GetDepartment = '[DepartmentSettings] Get DepartmentSettings',
	GetDepartmentSuccess = '[DepartmentSettings] Get DepartmentSettings Success',

	PatchDepartment = '[DepartmentSettings] Patch DepartmentSettings',
	PatchDepartmentSuccess = '[DepartmentSettings] Patch DepartmentSettings Success',

	GetTenant = '[DepartmentSettings] Get Tenant',
	GetTenantSuccess = '[DepartmentSettings] Get Tenant Success',

	PatchTenant = '[DepartmentSettings] Patch Tenant',
	PatchTenantSuccess = '[DepartmentSettings] Patch Tenant Success',

	SetTenant = '[DepartmentSettings] Set tenant',

	SetEditingTenant = '[DepartmentSettings] Set editing tenant',

	GetIntegrations = '[DepartmentSettings] Get Integrations',
	GetIntegrationsSuccess = '[DepartmentSettings] Get Integrations Success',

	GetRoundingRules = '[DepartmentSettings] Get rounding rules',
	GetRoundingRulesSuccess = '[DepartmentSettings] Get rounding rules success',

	SetEditingDepartment = '[DepartmentSettings] Set Editing Department',
	SetRoundingRules = '[DepartmentSettings] Set Rounding Rules Ordered',
}

export class GetIntegrations implements Action {
	public readonly type = EDepartmentSettingsActions.GetIntegrations;

	constructor() {
	}
}

export class GetIntegrationsSuccess implements Action {
	public readonly type = EDepartmentSettingsActions.GetIntegrationsSuccess;

	constructor(public integrations: QMIntegration[]) {
	}
}

export class GetDepartment implements Action {
	public readonly type = EDepartmentSettingsActions.GetDepartment;

	constructor(public id: number) {
	}
}

export class GetDepartmentSuccess implements Action {
	public readonly type = EDepartmentSettingsActions.GetDepartmentSuccess;

	constructor(public department: Department) {
	}
}

export class GetTenant implements Action {
	public readonly type = EDepartmentSettingsActions.GetTenant;

	constructor() {
	}
}

export class GetTenantSuccess implements Action {
	public readonly type = EDepartmentSettingsActions.GetTenantSuccess;

	constructor(public tenant: Tenant) {
	}
}

export class SetEditingTenant implements Action {
	public readonly type = EDepartmentSettingsActions.SetEditingTenant;

	constructor(public tenant: Tenant) {
	}
}

export class PatchDepartment implements Action {
	public readonly type = EDepartmentSettingsActions.PatchDepartment;

	constructor(public id: number, public payload: IPatchPayload, public emailVerificationPopup: boolean = false) {
	}
}

export class PatchDepartmentSuccess implements Action {
	public readonly type = EDepartmentSettingsActions.PatchDepartmentSuccess;

	constructor(public department: Department) {
	}
}

export class PatchTenant implements Action {
	public readonly type = EDepartmentSettingsActions.PatchTenant;

	constructor(public payload: ITenantPatchPayload, public emailVerificationPopup: boolean = false) {
	}
}

export class PatchTenantSuccess implements Action {
	public readonly type = EDepartmentSettingsActions.PatchTenantSuccess;

	constructor(public tenant: Tenant) {
	}
}

export class SetTenant implements Action {
	public readonly type = EDepartmentSettingsActions.SetTenant;

	constructor(public tenant: Tenant) {
	}
}

export class GetRoundingRules implements Action {
	public readonly type = EDepartmentSettingsActions.GetRoundingRules;

	constructor(public departmentId: number) {
	}
}

export class GetRoundingRulesSuccess implements Action {
	public readonly type = EDepartmentSettingsActions.GetRoundingRulesSuccess;

	constructor(public roundingRules: RoundingRule[]) {
	}
}

export class SetEditingDepartment implements Action {
	public readonly type = EDepartmentSettingsActions.SetEditingDepartment;

	constructor(public department: Department) {
	}
}

export class SetRoundingRules implements Action {
	public readonly type = EDepartmentSettingsActions.SetRoundingRules;

	constructor(public roundingRules: RoundingRule[]) {
	}
}

export type DepartmentSettingsActions =
	GetDepartment |
	GetDepartmentSuccess |
	PatchDepartment |
	PatchDepartmentSuccess |
	GetTenant |
	GetTenantSuccess |
	SetEditingTenant |
	PatchTenant |
	PatchTenantSuccess |
	SetTenant |
	GetIntegrations |
	GetIntegrationsSuccess |
	GetRoundingRules |
	GetRoundingRulesSuccess |
	SetEditingDepartment |
	SetRoundingRules
	;
